import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

export const logoutUser = async (token) => {
  try {
    const response = await axios.post(`${API_URL}/auth/logout`, {}, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });
    return response.data;
  } catch (error) {
    console.error('Logout API error:', error);
    throw error;
  }
};